import { render, staticRenderFns } from "./Tesseramento.vue?vue&type=template&id=e63c9960&"
import script from "./Tesseramento.vue?vue&type=script&lang=js&"
export * from "./Tesseramento.vue?vue&type=script&lang=js&"
import style0 from "./Tesseramento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports